import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import axios from 'axios';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';
import { formatDate } from '../../common/constants';
import { Table, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export default function EarningComponentsTable(props) {
  const [earningComponents, setEarningComponents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const updateEmpEarningComponents = useSelector(state => state.updateTable.updateEmpEarningComponents);

  async function getEarningComponents() {
    setLoading(true);
    let API_URL = props.fetch_id !== 9999
      ? `${process.env.REACT_APP_API_BASE_URL}/employee-master/view-earning-components/${props.fetch_id}`
      : `${process.env.REACT_APP_API_BASE_URL}/employee-master/view-earning-components/${props.employeeID}`;
    
    try {
      const response = await axios.get(API_URL);
      setEarningComponents(response.data.map((item, idx) => ({ ...item, key: item.earning_component_id || idx })));
    } catch (e) {
      if (e.response?.status === 401) {
        setNotify({ isOpen: true, message: 'Session Expired!', type: 'error' });
        setTimeout(() => navigate('/'), 1000);
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    getEarningComponents();
  }, []);

  useEffect(() => {
    if (updateEmpEarningComponents) {
      getEarningComponents();
      dispatch(updateTableActions.stopUpdateEmpEarningComponents());
    }
  }, [updateEmpEarningComponents]);

  const handleDelete = async (delete_id) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    try {
      const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/employee-master/delete-earning/${delete_id}`);
      if (res.status === 200) {
        getEarningComponents();
        setNotify({ isOpen: true, message: 'Successfully Deleted!', type: 'error' });
        dispatch(updateTableActions.startUpdateEmpEarningComponents());
      }
    } catch (e) {
      if (e.response?.status === 401) {
        setNotify({ isOpen: true, message: 'Session Expired!', type: 'error' });
        setTimeout(() => navigate('/'), 1000);
      }
    }
  };

  const columns = [
    {
      title: 'Earning Type',
      dataIndex: 'earningTypeName',
      key: 'earningTypeName',
      sorter: (a, b) => (a.earningTypeName || '').localeCompare(b.earningTypeName || ''),
    },
    {
      title: 'Effective Date',
      dataIndex: 'earning_date',
      key: 'earning_date',
      render: (val) => formatDate(val?.split('T')[0]),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (val) => val?.toLocaleString('en-IN'),
    },
    {
      title: 'Month',
      dataIndex: 'month',
      key: 'month',
    },
    {
      title: 'Year',
      dataIndex: 'year',
      key: 'year',
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 100,
      render: (_, record) => (
        <Button
          danger
          ghost
          size="small"
          icon={<DeleteOutlined />}
          onClick={() =>
            setConfirmDialog({
              isOpen: true,
              title: 'Are you sure to delete this record?',
              subTitle: "You can't undo this operation",
              onConfirm: () => handleDelete(record.earning_component_id),
            })
          }
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={earningComponents}
        loading={loading}
        size="small"
        bordered
        pagination={{
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} records`,
        }}
      />
      <Notification notify={notify} setNotify={setNotify} />
      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
    </div>
  );
}
